import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-book-sellerdispatch-labels',
  templateUrl: './book-sellerdispatch-labels.component.html',
  styleUrl: './book-sellerdispatch-labels.component.scss'
})
export class BookSellerdispatchLabelsComponent {
  groups: any[] = [];

  constructor(
    private dialogref: MatDialogRef<BookSellerdispatchLabelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    debugger
    console.log('📥 RAW DIALOG DATA =>', this.data);

    // API returns array of { DistributiveRep, records: [...] }
    const raw = Array.isArray(this.data?.addresslabels)
      ? this.data.addresslabels
      : Array.isArray(this.data)
        ? this.data
        : [];

    this.prepareData(raw);
  }

  prepareData(raw: any[]): void {
    if (!raw || raw.length === 0) {
      this.groups = [];
      console.warn('⚠️ No data to display');
      return;
    }

    this.groups = raw.map((group: any) => {
      const records = (group.records || []).map((item: any, index: number) => {
        const address = (item?.address ?? '').toString().trim();

        return {
          bse_id:      item?.bse_id      ?? '',
          name:        item?.name
                       ?? item?.bookseller_name
                       ?? item?.seller_name
                       ?? item?.title
                       ?? 'N/A',
          address:     address,
          district:    (item?.district ?? '').toString().trim(),
          taluka:      (item?.taluka   ?? '').toString().trim(),
          state:       (item?.state    ?? '').toString().trim(),
          pincode:     (item?.pincode  ?? '').toString().trim(),
          mobile_no:   (item?.mobile_no ?? '').toString().trim(),
          month:       item?.month     ?? '',
          year:        item?.year      ?? '',
          book_copies: Number(item?.total_book_copies ?? item?.book_copies ?? 0),
          book_names:  item?.book_names ?? '',
          rep_name:    item?.rep_name  ?? '',
        };
      });

      return {
        DistributiveRep: group.DistributiveRep || 'अनिर्धारित',
        records
      };
    });

    console.log('✅ FINAL GROUPS =>', this.groups);
  }

print(): void {

  if (!this.groups || this.groups.length === 0) {
    alert('No data to print.');
    return;
  }

  let html = `
  <!DOCTYPE html>
  <html>
  <head>
      <meta charset="UTF-8">
      <title>Book Seller Labels</title>

      <style>

      @page{
          size: A4 landscape;
          margin: 2mm;
      }

      body{
          font-family: Arial, 'Noto Sans Devanagari', sans-serif;
          margin: 0;
          padding: 0;
          font-size: 16px; /* 🔥 increased base font */
      }

      .page{
          page-break-after: always;
          padding: 2mm;
          box-sizing: border-box;
      }

      .page:last-child{
          page-break-after: auto;
      }

      .header{
          font-size: 19px; /* 🔥 increased */
          font-weight: bold;
          margin-bottom: 10px;
      }

      .grid{
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
      }

      .label{
          width: calc(25% - 9px);
          border: 1px solid #000;
          padding: 12px; /* 🔥 improved spacing */
          box-sizing: border-box;

          page-break-inside: avoid;
          break-inside: avoid;

          font-size: 16px; /* 🔥 increased */
          min-height: 120px;
      }

      .title{
          display: flex;
          justify-content: space-between;
          font-weight: bold;
          margin-bottom: 6px;
          font-size: 16px; /* 🔥 added */
      }

      </style>

  </head>

  <body>
  `;

  this.groups.forEach((grp: any) => {

    html += `
    <div class="page">

        <div class="header">
            वितरण प्रतिनिधी : ${grp.DistributiveRep || ''}
        </div>

        <div class="grid">
    `;

    grp.records.forEach((item: any) => {

      html += `
        <div class="label">

            <div class="title">
                <span>${item.name ?? ''}</span>
                <span>${item.book_copies ?? 0}</span>
            </div>

            <div>${item.address ?? ''}</div>

            ${item.taluka ? `<div>${item.taluka}</div>` : ''}

            <div>
                ${item.district ?? ''}
                ${item.pincode ? ' - ' + item.pincode : ''}
                ${item.state ? ' ' + item.state : ''}
            </div>

            ${item.mobile_no ? `<div>📞 ${item.mobile_no}</div>` : ''}

        </div>
      `;

    });

    html += `
        </div>

    </div>
    `;

  });

  html += `
  <script>
      window.onload = function() {
          window.print();
          window.onafterprint = function() {
              window.close();
          }
      }
  </script>
  </body>
  </html>
  `;

  const printWindow = window.open('', '_blank', 'width=1200,height=900');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  } else {
    alert('Please allow popups to print.');
  }
}
  close(): void {
    this.dialogref.close();
  }
}